export default __webpack_public_path__ + "static/media/Something went wrong page.2a6adf07.svg";